import { Card } from "../ui/card";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

const FREQ = [["none", "Nessuna (singola corsa)"], ["daily", "Giornaliera"], ["weekly", "Settimanale"], ["biweekly", "Ogni 2 settimane"], ["monthly", "Mensile"]];

export const RecurrenceSection = ({ recurrence, setRecurrence }) => (
  <Card className="p-6 border-slate-200 mb-5">
    <Label className="nx-label mb-3 block">Trasporto Ricorrente (es. dialisi settimanale)</Label>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <Label className="nx-label">Frequenza</Label>
        <Select value={recurrence.frequency} onValueChange={(v) => setRecurrence({ ...recurrence, frequency: v })}>
          <SelectTrigger data-testid="rec-frequency" className="mt-1.5"><SelectValue /></SelectTrigger>
          <SelectContent>{FREQ.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      {recurrence.frequency !== "none" && (
        <div>
          <Label className="nx-label">Numero di occorrenze</Label>
          <Input data-testid="rec-count" type="number" min={2} max={52} value={recurrence.count}
            onChange={(e) => setRecurrence({ ...recurrence, count: Math.max(2, Math.min(52, parseInt(e.target.value || "2", 10))) })}
            className="mt-1.5" />
        </div>
      )}
    </div>
    {recurrence.frequency !== "none" && (
      <p className="text-xs text-slate-500 mt-3">
        Verranno generate <b>{recurrence.count}</b> corse a partire dalla Data Evento, ognuna con codice univoco e notifica ai partner.
      </p>
    )}
  </Card>
);
